<script>import { getIcon } from "../data/icons";
import { t, Verbiage } from "@infinitro/content";
const SearchIcon = getIcon("SearchIcon");
</script>

{#if typeof SearchIcon === 'string'}
	<img src={SearchIcon} alt={$t(Verbiage.search_icon_alt, 'alts')} />
{:else if typeof SearchIcon === 'function'}
	<svelte:component this={SearchIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
